import { render, staticRenderFns } from "./TermsBlock.vue?vue&type=template&id=2a5a7742&scoped=true&"
import script from "./TermsBlock.vue?vue&type=script&lang=js&"
export * from "./TermsBlock.vue?vue&type=script&lang=js&"
import style0 from "./TermsBlock.vue?vue&type=style&index=0&id=2a5a7742&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a7742",
  null
  
)

export default component.exports